import { createAsyncThunk } from "@reduxjs/toolkit";
import { SendAIMessage, StartAISession, EndAISession, GetAIConversationHistory } from "helpers/api_method";

export const sendAIMessage = createAsyncThunk(
    "aiAssistant/sendMessage",
    async (data: { question: string; session_id?: string }, { rejectWithValue }) => {
        try {
            const response: any = await SendAIMessage(data);
            if (response && response.status === true) {
                return response.data;
            } else {
                return rejectWithValue(response?.message || "Failed to send message");
            }
        } catch (error: any) {
            return rejectWithValue(error?.response?.data?.message || error?.message || "Failed to send message");
        }
    }
);

export const startAISession = createAsyncThunk(
    "aiAssistant/startSession",
    async (_, { rejectWithValue }) => {
        try {
            const response: any = await StartAISession();
            if (response && response.status === true) {
                return response.data;
            } else {
                return rejectWithValue(response?.message || "Failed to start session");
            }
        } catch (error: any) {
            return rejectWithValue(error?.response?.data?.message || error?.message || "Failed to start session");
        }
    }
);

export const endAISession = createAsyncThunk(
    "aiAssistant/endSession",
    async (sessionId: string, { rejectWithValue }) => {
        try {
            const response: any = await EndAISession(sessionId);
            if (response && response.status === true) {
                return response.data;
            } else {
                return rejectWithValue(response?.message || "Failed to end session");
            }
        } catch (error: any) {
            return rejectWithValue(error?.response?.data?.message || error?.message || "Failed to end session");
        }
    }
);

export const getAIConversationHistory = createAsyncThunk(
    "aiAssistant/getHistory",
    async (limit: number = 10, { rejectWithValue }) => {
        try {
            const response: any = await GetAIConversationHistory(limit);
            if (response && response.status === true) {
                return response.data;
            } else {
                return rejectWithValue(response?.message || "Failed to get history");
            }
        } catch (error: any) {
            return rejectWithValue(error?.response?.data?.message || error?.message || "Failed to get history");
        }
    }
);

